import React from 'react';
import CameraOverlaysContent from './CameraOverlaysContent';
import Sheet from '../common/Sheet';
import { matchTabletSheet, onTabletSheetChange } from '../util/tabletSheet';

/**
 * CameraOverlaysMenu — the desktop bottom-left "Camera overlays" gear (redesign #86bb5dx62, Mock D4).
 * A live-viewing overlay menu, DISTINCT from the Setup screen. The gear button toggles an upward
 * popover whose body is the shared CameraOverlaysContent (Camera Info / Object Detection / License
 * Plates toggles + Snapshot-all / Reset-zoom actions) — the SAME body the mobile/tablet
 * CameraOverlaysSheet renders, so the two never drift.
 *
 * "Camera Info" = the FPS/bitrate/codec/resolution readout (overlayPrefs.metadata, Java parity);
 * the name+time overlay is "Name & Timestamp" (Setup > Display). The overlayPrefs.recBox pref is
 * reserved for the recording/alert box (L-I2, no UI yet), so it has no row here.
 *
 * Desktop uses this popover; mobile/tablet mirror it as a bottom sheet. Rendered in the desktop
 * bottom bar → desktop-only via CSS; never affects mobile/tablet.
 *
 * Props: onSnapshotAll(), onResetZoom()
 */
class CameraOverlaysMenu extends React.Component {
    state = { open: false, tabletSheet: matchTabletSheet() };

    componentDidMount() {
        document.addEventListener('mousedown', this.onDocMouseDown);
        this._offTablet = onTabletSheetChange((m) => this.setState({ tabletSheet: m }));
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onDocMouseDown);
        if (this._offTablet) this._offTablet();
    }
    onDocMouseDown = (e) => {
        if (this.state.open && this._wrap && !this._wrap.contains(e.target)) this.setState({ open: false });
    };
    toggleOpen = () => this.setState((s) => ({ open: !s.open }));
    close = () => this.setState({ open: false });

    render() {
        const { open, tabletSheet } = this.state;
        const { onSnapshotAll, onResetZoom } = this.props;
        const body = (
            <CameraOverlaysContent
                onSnapshotAll={() => { this.close(); onSnapshotAll && onSnapshotAll(); }}
                onResetZoom={() => { this.close(); onResetZoom && onResetZoom(); }}
            />
        );
        return (
            <div className={'live-ovmenu' + (open ? ' live-ovmenu--show' : '')} ref={(el) => { this._wrap = el; }}>
                <button className="live-ovmenu__btn" onClick={this.toggleOpen} title="Camera overlays" aria-haspopup="menu" aria-expanded={open}>
                    {/* "tune" icon (not a gear) — the gear reads as Settings/Setup; this control is
                        view overlays + bulk actions, distinct from Setup (David #86bb5dx62). */}
                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z" /></svg>
                </button>
                {/* Tablet (< 1280): the mobile bottom SHEET; desktop (>= 1280): the anchored popover. Same body
                    either way (David #86bb7phhh — tablet = sheets, desktop = modals). */}
                {tabletSheet ? (
                    open && (
                        <Sheet className="app-sheet live-bar-sheet" title="Camera overlays" ariaLabel="Camera overlays" onClose={this.close}>
                            {body}
                        </Sheet>
                    )
                ) : (
                    <div className="live-ovmenu__pop" role="menu">
                        <div className="live-ovmenu__hd">Camera overlays</div>
                        {body}
                    </div>
                )}
            </div>
        );
    }
}

export default CameraOverlaysMenu;
